// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeSeasonStartOptionsBody = {
  poolId: string;
};

export type typeSeasonStartOptionsOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    nextSeasonYearDefault: number;
    nextSeasonTitleDefault: string;
    providerDataReady: boolean;
    unsettledContest?: { contestId: string; contestName: string } | null;
  };
};

export type typeSeasonStartOptionsOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeSeasonStartOptionsOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeSeasonStartOptionsOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaSeasonStartOptionsBody = {
  type: "object",
  properties: { poolId: { type: "string", maxLength: 3000, minLength: 1 } },
  required: ["poolId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createSeasonStartOptions(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaSeasonStartOptionsBody);
  }

  return async function postSeasonStartOptions(
    payload: typeSeasonStartOptionsBody,
  ): Promise<
    typeSeasonStartOptionsOutput200 | typeSeasonStartOptionsOutput400
  > {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postSeasonStartOptions" failed before calling the network. #4424e4e04ebc`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#4424e4e04ebc" },
        },
        data: null,
      } as typeSeasonStartOptionsOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/season/start-options`,
      httpMethod: "POST",
      options,
    })) as typeSeasonStartOptionsOutput200 | typeSeasonStartOptionsOutput400;
  };
}
